import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppSettingService } from './services/app.settings';

export class Api {
    constructor() { }

    protected getApiUrl(): string {
        return environment.API_URL;
    }

    protected getApiVersion(): string {
        return environment.API_VERSION;
    }
}
